import { c as _c } from "react/compiler-runtime";
import { type JSX } from "react";
interface LimitIconProps {
  readonly className?: string | undefined;
}

/**
 * Icon for indicating a limit or maximum has been reached
 */
export default function LimitIcon(t0) {
  const $ = _c(6);
  const {
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M19 5H5C3.89543 5 3 5.89543 3 7V17C3 18.1046 3.89543 19 5 19H19C20.1046 19 21 18.1046 21 17V7C21 5.89543 20.1046 5 19 5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    t3 = <path d="M16 12H8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    t4 = <path d="M16 9H12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    t5 = <path d="M16 15H14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
  } else {
    t2 = $[0];
    t3 = $[1];
    t4 = $[2];
    t5 = $[3];
  }
  let t6;
  if ($[4] !== className) {
    t6 = <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">{t2}{t3}{t4}{t5}</svg>;
    $[4] = className;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  return t6;
}